<template>
  <div class="gap-fill-game">
    <div class="head">
      <slot name="head"></slot>
    </div>
    <div class="gap-fill">
      <slot name="content"></slot>
    </div>
    <div class="button-wrapper">
      <p class="error" v-show="showError && !isValid">Essayez de corriger vos erreurs !</p>
      <button v-if="isValid && showNextButton" class="button" @click="$emit('next')">Suivant</button>
      <button v-else-if="!isValid" class="button" :class="{ disabled: !buttonEnabled }" @click="$emit('validate')">Valider</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GapFillGameTemplate',
  props: {
    buttonEnabled: {
      type: Boolean,
      required: true
    },
    isValid: {
      type: Boolean,
      required: true
    },
    showError: {
      type: Boolean,
      required: true
    },
    showNextButton: {
      type: Boolean,
      required: false,
      default () {
        return true
      }
    }
  }
}
</script>

<style lang="scss">
.gap-fill-game {
  padding: 5px 80px;
  .head {
    min-height: 220px;
    margin-bottom: 30px;
    img {
      max-width: 100%;
    }
  }
  .gap-fill {
    p {
      line-height: 3.8rem;
      text-align: left;
      font-size: 1.25rem;
    }
  }
  .button-wrapper {
    position: relative;
    .error {
      color: #ff1010;
      font-weight: 700;
      font-size: 1.2rem;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    .button {
      margin: 0 auto;
    }
  }
}
</style>
